import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Platformfeature() {
  return (
    <section className="platform_feature p-100 text_reck">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="platform_img_reck">
              <StaticImage
                src="../../../images/case-studies/reckncase/audience.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={658}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>
              Target <span>Audience</span>
            </h2>
            <p>
              Reck’N was methodically created to engage a dual
              audience—customers looking for immersive dining experiences and
              restaurants determined to improve service quality.
            </p>
            <p>
              The app intended to bond the gap between patrons and eateries,
              providing more than just a booking.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Platformfeature;
